<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >ข้อมูลยื่นคำร้อง</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgentInfo"
                >ขอเปลี่ยนแปลงข้อมูลตัวแทน</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              เปลี่ยนแปลงชื่อ - นามสกุล (ภาษาไทย)
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <a>
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </a>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          เปลี่ยนแปลงชื่อ - นามสกุล (ภาษาไทย)
        </div>
      </div>
      <!-- Mobile -->
      <div class="col">
        <div
          class="title d-none d-lg-block border-bottom"
          style="font-family: DB Heavent; color: #0057a8"
        >
          เปลี่ยนแปลงชื่อ - นามสกุล (ภาษาไทย)
        </div>
        <div class="pb-3 pb-lg-3">
          <div class="mt-4 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              ชื่อ - นามสกุล เดิม
            </div>
          </div>
          <div class="d-lg-flex align-items-center">
            <div class="blue-1 fs-5 mt-1 mt-lg-1 font-family">
              อุดมศักดิ์ พุธปัญญา
            </div>
          </div>
        </div>
        <div class="row font-family fs-5">
          <div class="col-12 col-md-6 col-lg-6">
            <div class="form-group" style="margin-bottom: 1em">
              <label>คำนำหน้าชื่อ<span class="required">*</span> </label>
              <div class="bg-white form-group">
                <v-select
                  v-model="PreNameTh"
                  :reduce="(option) => option.value"
                  :options="[
                    { id: 1, label: 'นาย', value: 'นาย' },
                    { id: 2, label: 'นาง', value: 'นาง' },
                    { id: 3, label: 'นางสาว', value: 'นางสาว' },
                  ]"
                  placeholder="กรุณาเลือกคำนำหน้าชื่อ"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="field a-field page__field">
                ชื่อ<span class="required">*</span>
                <input v-model="NameTh"
                  type="text"
                  class="field__input a-field__input"
                  autocomplete="off"
                />
              </label>
              <span class="text-danger" style="display: inline-block"></span>
            </div>
            <div class="form-group">
              <label class="field a-field page__field">
                นามสกุล<span class="required">*</span>
                <input v-model="SurNameTh"
                  type="text"
                  class="field__input a-field__input"
                  autocomplete="off"
                />
              </label>
              <span class="text-danger" style="display: inline-block"></span>
            </div>
          </div>
        </div>
        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button
              type="button"
              class="btn btn-light btn-cancel font-family d-inline-block"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <router-link to="/AgentInfo">
              <button
                type="button"
                class="btn btn-continue font-family d-inline-block"
                @click="EnterNext()"
              >
                ดำเนินการต่อ
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade font-family"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-model fw-normal"
            data-bs-dismiss="modal"
          >
            ไม่ต้องการ
          </button>
          <button type="button" class="btn btn-model fw-normal">ต้องการ</button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import LoadingBs5 from "@/components/frontend/LoadingBs5";

export default {
  name: "EditNameTh",
  components: {
    Menu,
    LoadingBs5,
  },
  data() {
    return {
      PreNameTh: '',
      NameTh: '',
      SurNameTh: '',
      Loading: false,
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
  },
  methods: {
    EnterNext() {
      if(this.PreNameTh !== " " && this.NameTh !== " " && this.SurNameTh !== "" ? this.$store.state.FullNameTh = this.PreNameTh + " " + this.NameTh + " " + this.SurNameTh : this.$store.state.FullNameTh = '')
      
      this.$store.state.PreNameTh = this.PreNameTh;
      this.$store.state.NameTh = this.NameTh;
      this.$store.state.SurNameTh = this.SurNameTh;
    },
  },
};
</script>

<style scoped>
</style>